// extracted by mini-css-extract-plugin
export var container = "styles-module__container___uMiw3";
export var buttonsContainer = "styles-module__buttonsContainer___XaoGQ";
export var colorDistanceSpacer = "styles-module__colorDistanceSpacer____aKOv";
export var routeFormHeader = "styles-module__routeFormHeader___Q7JFV";
export var formButtonsContainer = "styles-module__formButtonsContainer___LF_Y_";
export var formButton = "styles-module__formButton___bNg6p";